import { Tag } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { ApprovalGroupItemTitleProps } from '../../types';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const ApprovalGroupTitle: FC<ApprovalGroupItemTitleProps> = ({
  condition,
  isShowInformationTag,
  groupName,
}) => {
  return (
    <div className={cx('container')}>
      {isShowInformationTag && (
        <Tag className={cx('tag')} closable={false} outline={false}>
          {groupName}
        </Tag>
      )}
      <span className={cx('description')}>{condition}</span>
    </div>
  );
};
